<template>
  <div class="container">
    <h5 class="title is-5">Configure Notifications</h5>
    <div class="level" v-if="!addFormVisible">
      <div class="level-left">
        <div class="level-item">
          <b-button type="is-primary" class="is-small" @click="toggleAddNotificationHandler()">Add Notification Handler</b-button>
        </div>
      </div>
    </div>
    <div class="container has-text-left" v-if="addFormVisible" style="margin-bottom: 1rem;">
      <div class="block">
        <b-field label="Channel">
          <b-select v-model="channel">
            <option v-for="ch in availableNotificationChannels"
                    :key="ch"
                    :value="ch"
            >{{ch}}</option>
          </b-select>
        </b-field>
        <b-field label="URL">
          <b-input v-model="url" placeholder="Enter URL..." required/>
        </b-field>
        <b-field label="Username">
          <b-input v-model="user" placeholder="Auth user (optional)..." name="butler_nh_user"/>
        </b-field>
        <b-field label="Password">
          <b-input v-model="pass" placeholder="Auth pass (optional)..." type="password" name="butler_nh_pass"/>
        </b-field>
      </div>
      <div class="buttons">
        <b-button type="is-danger" class="is-outlined is-small" @click="handleCloseFormAddNotificationHandler">Back</b-button>
        <b-button type="is-success" class="is-small" :disabled="!validAddNotificationHandlerFields()" @click="handleAddNotificationHandler">Add</b-button>
      </div>
      <hr />
    </div>
    <div v-if="notificationHandlers.length > 0">
      <b-table
          :striped="true"
          :narrowed="true"
          :data="tableData"
          :detailed="true"
          detail-key="id"
      >
        <template slot-scope="props">
          <b-table-column field="num" numeric>{{props.row.num}}</b-table-column>
          <b-table-column field="channel" label="Channel" left>{{props.row.channel}}</b-table-column>
          <b-table-column field="url" label="URL">{{props.row.url}}</b-table-column>
          <b-table-column field="user" label="User">{{props.row.user}}</b-table-column>
          <b-table-column field="pass" label="Pass">{{props.row.hiddenPassword}}</b-table-column>
        </template>

        <template slot="detail" slot-scope="props">
          <div>
            <div class="buttons">
              <b-button class="is-danger is-small" @click="handleDeleteNotificationHandler(props.row.channel)">Delete</b-button>
            </div>
          </div>
        </template>
      </b-table>
    </div>
    <div v-else style="margin-top: 1rem;">
      No notification handlers added.
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import BTable from "buefy/src/components/table/Table";
  import BTableColumn from "buefy/src/components/table/TableColumn";
  import BButton from "buefy/src/components/button/Button";
  import BField from "buefy/src/components/field/Field";
  import BSelect from "buefy/src/components/select/Select";
  import BInput from "buefy/src/components/input/Input";

  export default {
    components: {
      BInput,
      BSelect,
      BField,
      BButton,
      BTableColumn,
      BTable },
    name: "screen-configure-notifications",
    data() {
      return {
        addFormVisible: false,
        channel: '',
        url: '',
        user: '',
        pass: ''
      };
    },
    computed: {
      ...mapGetters('notifications', ['notificationHandlers', 'notificationChannels']),
      tableData() {
        const ret = [];
        let num = 0;
        this.notificationHandlers.forEach(item => {
          num++;
          ret.push({
            ...item,
            hiddenPassword: '******',
            num
          });
        });

        return ret;
      },
      availableNotificationChannels() {
        const ret = [];
        this.notificationChannels.forEach(ch => {
          let found = false;
          this.notificationHandlers.forEach(item => {
            if (item.channel === ch) {
              found = true;
            }
          });
          if (!found) {
            ret.push(ch);
          }
        });

        return ret;
      }
    },
    methods: {
      ...mapActions('notifications', ['deleteNotificationHandler', 'addNotificationHandler']),
      handleDeleteNotificationHandler(channel) {
        if (confirm("Are you sure ?")) {
          this.deleteNotificationHandler(channel);
        }
      },
      toggleAddNotificationHandler() {
        this.addFormVisible = !this.addFormVisible;
      },
      handleCloseFormAddNotificationHandler() {
        this.toggleAddNotificationHandler();
      },
      handleAddNotificationHandler() {
        this.addNotificationHandler({
          channel: this.channel,
          url: this.url,
          user: this.user,
          pass: this.pass
        });
        this.toggleAddNotificationHandler();
      },
      validAddNotificationHandlerFields() {
        if (this.channel.length < 1) {
          return false;
        }

        if (this.url.length < 6) {
          return false;
        }

        return true;
      }
    },
    mounted() {
      if (this.availableNotificationChannels.length > 0) {
        this.channel = this.availableNotificationChannels[0];
      }
    }
  }
</script>

<style scoped>

</style>